import { Component } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/analytics/analytics.service';
import { LanguageService } from 'src/app/language/language.service';
import { SubscriptionService } from 'src/app/subscription/subscription.service';

@Component({
  selector: 'app-subscription-cancel-reason',
  templateUrl: './subscription-cancel-reason.page.html',
  styleUrls: ['./subscription-cancel-reason.page.scss'],
})
export class SubscriptionCancelReasonPage {

  selectedReason: string | null = null;
  otherInputValue = '';
  additionalFeedback = '';

  cancelReasons = [
    { key: 'missingFeatures', value: 'missingFeatures' },
    { key: 'lowUsage', value: 'lowUsage' },
    { key: 'technicalIssues', value: 'technicalIssues' },
    { key: 'financialIssues', value: 'financialIssues' },
    { key: 'pauseReturn', value: 'pauseReturn' },
    { key: 'otherSolution', value: 'otherSolution' },
  ];

  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private subscriptionService: SubscriptionService,
    private analyticsService: AnalyticsService,
    public lang: LanguageService
  ) {}

  selectOther() {
    this.selectedReason = 'other';
  }

  isSubmitDisabled(): boolean {
    if (!this.selectedReason) {
      return true;
    }

    if (this.selectedReason === 'other' && !this.otherInputValue) {
      return true;
    }

    return false;
  }

  async submit() {
    if (!this.selectedReason) return;
    const selectedOption = this.selectedReason;
    const params: any = {};
    params[selectedOption] = 1;

    this.analyticsService.logEvent(
      'subscription_cancel_reason_select',
      params,
      selectedOption
    );

    this.analyticsService.logEvent(
      'subscription_cancel_reason_continue_click'
    );

    await this.modalCtrl.dismiss();

    this.subscriptionService.manageSubscriptions();
  }

  goBack() {
    this.analyticsService.logEvent(
      'subscription_cancel_reason_back_click'
    );

    this.modalCtrl.dismiss().catch(() => {
      this.navCtrl.back();
    });
  }
}
